import { Component, inject, ViewChild } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '../../components/modal/modal.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { DropdownService } from '../../services/dropdown.service';
import { HeaderComponent } from "../../components/header/header.component";
import { SearchInputComponent } from "../../components/search-input/search-input.component";
import { ButtonComponent } from "../../components/button/button.component";
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { BulkUploadComponent } from "../../components/bulk-upload/bulk-upload.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { RolePermissionMappingService } from '../../services/role-permission-mapping.service';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { StreamService } from '../../services/stream.service';
import { ValidationService } from '../../services/validation.service';
import { NgIf } from '@angular/common';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';
import { FormService } from '../../services/form.service';

@Component({
  selector: 'app-stream-list-page',
  imports: [HeaderComponent, SearchInputComponent, ButtonComponent, AgGridListComponent, ConfirmationPopupComponent, ModalComponent, TextInputComponent, BulkUploadComponent, ReactiveFormsModule, PluralPipe, FormsModule, NgIf, DropdownUploadButtonComponent],
  templateUrl: './stream-list-page.component.html',
  styleUrl: './stream-list-page.component.css'
})
export class StreamListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Stream';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];
  isSubmitting = false;
  show_menu = false;
  fs = inject(FormService);

  columns: any = [
    { field: 'name', headerName: 'Stream Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Code', filter: true, flex: 1, },
    { headerName: "", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 130, minWidth: 130, maxWidth: 130 }
  ];

  bulk_columns_download: any = [
    { column_name: 'Stream Name', type: 'text', return_as: 'name' },
    { column_name: 'Code', type: 'text', return_as: 'code' },
  ];

  bulk_columns = [
    { column_name: 'Stream Name', type: 'text', return_as: 'name', sample_value: 'Science', is_unique: true, regex: this.vs.name_pattern, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'Stream Code', type: 'text', return_as: 'code', sample_value: '001', min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, regex: this.vs.code_pattern },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_course_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_course_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_course_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this), permissions: this.gs.user_role_data?.masters_course_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ss: StreamService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      // university_id: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['university']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.ss.get_list(filter);
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  download() {
    this.fs.bulk_download(this.ss, 'get_list', this.bulk_columns_download, 'Stream', this.params);
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }
  open_view_modal(item: any) {
    console.log(item);
    this.selected_ids = item || {};
    this.view_modal?.open();
  }
  async delete() {
    try {
      let res = await this.ss.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('stream');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.ss.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('stream');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.ss.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.ds.invalidate_dropdown_cache('stream');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.ss.get(item.id);
      this.selected_ids = this.gs.addHierarchyIds({ ...response.data });
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.ss.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ss.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('stream');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.ss, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

}
